import styles from './Components.module.scss';
import React, { useCallback } from 'react';
import { Button } from 'src/v2/commonComponents/Button';
import { AmpOnboardingPageStep } from 'src/v2/pages/auth/AmpOnboardingPage/common';

interface ExistingPaidUserSectionProps {
  setStep: (step: AmpOnboardingPageStep) => void;
}

export const ExistingPaidUserSection = ({
  setStep,
}: ExistingPaidUserSectionProps) => {
  const toSelectOwnerEmail = useCallback(() => {
    setStep(AmpOnboardingPageStep.ONBOARD);
  }, [setStep]);

  return (
    <div className={styles.root}>
      <h2 className={styles.heading}>You currently have a different plan</h2>
      <p>
        We are unable to cancel your existing plan. Please try using a different
        email address or contact us at support@ninjatech.ai for assistance.
      </p>
      <div className={styles.row}>
        <Button onClick={toSelectOwnerEmail}>Try with a different email</Button>
      </div>
    </div>
  );
};
